import React from 'react'
import PropTypes from 'prop-types'

import Tabs from '../../molecules/Tabs'

import './style.scss'

const FundDetailTabs = ({ id, fundDetailTabsConfig, activeIndex, moreContent, onTabChange }) => {
  return (
    <div className="fil-fund-detail__tabs-container">
      <Tabs
        id={id}
        defaultActiveIndex={activeIndex}
        tabsConfig={fundDetailTabsConfig}
        moreContent={moreContent}
        onTabChange={onTabChange}
      />
    </div>
  )
}

FundDetailTabs.propTypes = {
  id: PropTypes.string.isRequired,
  fundDetailTabsConfig: PropTypes.shape({
    tabs: PropTypes.array.isRequired,
    panels: PropTypes.array.isRequired,
    panelsFunctions: PropTypes.array.isRequired
  }).isRequired,
  activeIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  moreContent: PropTypes.string,
  onTabChange: PropTypes.func
}

FundDetailTabs.defaultProps = {
  activeIndex: 0,
  moreContent: '',
  onTabChange: () => {}
}

export default FundDetailTabs
